import _storage from "redux-persist/lib/storage";

export const storage = _storage;
